// 直播页面路径
const live = [
    {
        path: '/liveMain',
        name: 'liveMain',
        meta: { breadcrumb: '直播中心' },
        component: () => import('@/views/live/LiveMain.vue'),
        // children: [{
        //     path: '/live',
        //     name: 'live',
        //     meta: { breadcrumb: '直播间' },
        //     component: () => import('@/views/live/LiveRoom.vue')
        // }]
    }, 
]
export default live